// Stripe configuration utility
export const getStripePublishableKey = (): string => {
  const isProduction = window.location.hostname === 'vocalzing.com';
  
  if (isProduction) {
    return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
  }
  
  // Use sandbox key for development/preview
  return import.meta.env.VITE_STRIPE_SANDBOX_PUBLISHABLE_KEY || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
};
